export default __webpack_public_path__ + "static/media/w2.aa2e443f.png";